// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL, DASHBOARD_URL } from '../../configs';
import { toastTypes } from '../../enums';
import getRoot from '../root';

const DEFAULT_AUTH_URL = `https://www.wix.com/app-oauth-installation/consent?token=&appId=0012f1cd-2f95-40f3-8962-bb51278751d4&redirectUrl=${encodeURIComponent(DASHBOARD_URL)}/integrations/WiX&state=WiX`;

const useWiXStore = create((set, get) => ({
  configs: { enabled: false },
  embeddedScriptParams: {},
  loading: false,
  authUrl: DEFAULT_AUTH_URL,

  reset: () => set({ configs: {}, loading: false }),

  setConfigField: (name, value) => set((s) => ({ configs: { ...s.configs, [name]: value } })),

  getAuthUrl: async () => {
    try {
      const res = await axios.get(`${API_URL}/api/integrations/Wix/auth-url`);
      if (res.data.success) set({ authUrl: res.data.authUrl });
    } catch (e) { /* ignore */ }
    return null;
  },

  linkAccounts: async (instanceToken) => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${API_URL}/api/integrations/Wix/link-accounts`, { instanceToken });
      if (data.success) {
        root.success('Successfully linked Movology & Wix accounts!', toastTypes.linkAccounts);
        root.clearToast(toastTypes.linkAccounts);
      }
    } catch (err) {
      root.failure('Failed to link Mov & Wix accounts', toastTypes.linkAccounts);
    }
    set({ loading: false });
  },

  getConfigs: async () => {
    try {
      set({ loading: true });
      const { data } = await axios.get(`${API_URL}/api/integrations/Wix/config`);
      if (data.success) set((s) => ({ configs: { ...s.configs, ...data.config } }));
    } catch (err) { /* ignore */ } finally {
      set({ loading: false });
    }
  },

  updateConfigs: async () => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${API_URL}/api/integrations/Wix/config`, { ...get().configs });
      if (data.success) {
        root.success('Successfully updated the configurations.', toastTypes.wixUpdateConfigs);
        root.clearToast(toastTypes.wixUpdateConfigs);
      } else throw new Error();
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.wixUpdateConfigs);
    } finally {
      get().getConfigs();
      set({ loading: false });
    }
  },

  getEmbeddedScriptParams: async () => {
    try {
      set({ loading: true });
      const { data } = await axios.get(`${API_URL}/api/integrations/Wix/embedded-scripts`);
      if (data.success) set({ embeddedScriptParams: data.embeddedScriptParams });
      else throw new Error();
    } catch (e) { /* ignore */ }
    set({ loading: false });
  },
}));

export default useWiXStore;
